/* ZeroNic, cart drawer backed by the Shopify AJAX Cart API.
   Replaces the source site's localStorage cart. The drawer markup is re-rendered
   server-side via the Section Rendering API so Liquid keeps formatting money. */
(function () {
  'use strict';

  var SECTION_ID = 'zn-cart-drawer';

  function $(s, c) {
    return (c || document).querySelector(s);
  }
  function $all(s, c) {
    return Array.prototype.slice.call((c || document).querySelectorAll(s));
  }

  var isOpen = false;
  var lastFocused = null;
  var busy = false;

  function wrapper() {
    return document.getElementById('shopify-section-' + SECTION_ID);
  }
  function root() {
    return $('[data-cart-root]');
  }
  function panel() {
    var r = root();
    return r ? $('aside', r) : null;
  }
  function backdrop() {
    var r = root();
    return r ? r.querySelector(':scope > [data-cart-close]') : null;
  }

  /* ---------- open / close ---------- */
  function applyOpenStyles() {
    var r = root(), p = panel(), b = backdrop();
    if (!r) return;
    if (isOpen) {
      r.classList.remove('invisible');
      r.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        if (b) b.style.opacity = '1';
        if (p) p.style.transform = 'translateX(0)';
      });
    } else {
      if (b) b.style.opacity = '0';
      if (p) p.style.transform = 'translateX(100%)';
      r.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  function openDrawer() {
    if (isOpen) return;
    lastFocused = document.activeElement;
    isOpen = true;
    applyOpenStyles();
    var closeBtn = $('[data-cart-close]', panel());
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;
    applyOpenStyles();
    var r = root();
    setTimeout(function () {
      if (!isOpen && r) r.classList.add('invisible');
    }, 300);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.style.opacity = '1';
    el.style.transform = 'translateX(-50%) translateY(0)';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.style.opacity = '0';
      el.style.transform = 'translateX(-50%) translateY(1rem)';
    }, 2200);
  }

  /* ---------- badge ---------- */
  function updateBadge(count) {
    var badge = $('[data-cart-count]');
    if (!badge) return;
    badge.textContent = count;
    badge.classList.toggle('opacity-0', count === 0);
  }

  /* ---------- re-render the drawer from the server ---------- */
  function refresh() {
    return fetch(window.location.pathname + '?section_id=' + SECTION_ID, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Section render failed: ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var w = wrapper();
        if (!w) return;
        // The response is the section wrapper plus its contents; take the inner part.
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('shopify-section-' + SECTION_ID) || doc.body;
        w.innerHTML = fresh.innerHTML;

        var r2 = root();
        var count = r2 ? parseInt(r2.getAttribute('data-cart-count-value') || '0', 10) : 0;
        updateBadge(count);

        // The nodes were replaced, so restore whatever open state we were in.
        if (isOpen) {
          var p = panel(), b = backdrop(), rr = root();
          if (rr) rr.classList.remove('invisible');
          if (rr) rr.setAttribute('aria-hidden', 'false');
          if (p) p.style.transform = 'translateX(0)';
          if (b) b.style.opacity = '1';
        }
      });
  }

  /* ---------- cart mutations ---------- */
  function addToCart(form) {
    if (busy) return;
    busy = true;
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');

    var body = new FormData(form);
    // Ask Shopify to hand back the re-rendered drawer in the same round trip.
    body.append('sections', SECTION_ID);

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        // /cart/add.js returns a single item for `id` posts and an `items`
        // array for `items[]` posts (the bundle builder uses the latter).
        var name;
        if (data.items && data.items.length) {
          name = data.items.length > 1
            ? data.items.length + ' items'
            : (data.items[0].product_title || data.items[0].title);
        } else {
          name = data.product_title || data.title || 'Item';
        }
        // Buy-now forms skip the drawer and go straight to checkout.
        if (form.hasAttribute('data-zn-buy-now')) {
          window.location.href = '/checkout';
          return;
        }
        return refresh().then(function () {
          toast(name + ' added to cart');
          openDrawer();
        });
      })
      .catch(function (err) {
        toast((err && err.description) || 'Could not add to cart.');
      })
      .finally(function () {
        busy = false;
        if (btn) btn.removeAttribute('aria-busy');
      });
  }

  function changeLine(line, quantity, fromDrawer) {
    if (busy) return;
    busy = true;
    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart change failed');
        return r.json();
      })
      .then(function () {
        // The cart page renders its own line items, which this refresh does not
        // touch, reload so its totals and rows stay truthful.
        if (!fromDrawer) {
          window.location.reload();
          return;
        }
        return refresh();
      })
      .catch(function () {
        toast('Could not update the cart.');
        busy = false;
      })
      .finally(function () {
        if (fromDrawer) busy = false;
      });
  }

  /* ---------- delegated events (survive drawer re-render) ---------- */
  function init() {
    var r = root();
    updateBadge(r ? parseInt(r.getAttribute('data-cart-count-value') || '0', 10) : 0);

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-zn-add-form]');
      if (!form) return;
      e.preventDefault();
      addToCart(form);
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) {
        e.preventDefault();
        openDrawer();
        return;
      }
      if (e.target.closest('[data-cart-close]')) {
        e.preventDefault();
        closeDrawer();
        return;
      }

      var qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        e.preventDefault();
        changeLine(
          parseInt(qtyBtn.getAttribute('data-cart-qty'), 10),
          parseInt(qtyBtn.getAttribute('data-qty-to'), 10),
          !!qtyBtn.closest('[data-cart-root]')
        );
        return;
      }

      var removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        changeLine(
          parseInt(removeBtn.getAttribute('data-cart-remove'), 10),
          0,
          !!removeBtn.closest('[data-cart-root]')
        );
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) {
        closeDrawer();
        return;
      }
      // Focus trap inside the open drawer.
      if (e.key !== 'Tab' || !isOpen) return;
      var p = panel();
      if (!p) return;
      var focusable = $all(
        'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])',
        p
      ).filter(function (el) {
        return el.offsetParent !== null;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
